var performanceEnv = require('core/env/performance');
var Logger = require('core/utils/logger');
var cmabApiCallStartTime = null;

/**
 * This file is used to measure the performance of the CMAB API calls.
 *
 * `sendCmabApiInitiateCall` measures the time taken to start the execution of the snippet and elapsed time to initiate the CMAB API call.
 * example: [[87.2, 19.1]] - At around 87.2ms the snippet started it's execution and it took 19.1ms to initiate the CMAB API call.
 *
 * `sendCmabApiCall` measures the time taken from the initiation of the CMAB API call to receiving the response.
 * example: [[106.4, 491.1]] - At 106.4ms point of snippet execution, the API call was initiated and it took 491.1ms to API call to resolve.
 *
 * Both can be found under RUM data's userTimings object which co-relates to extras.activeExperimentIds object
 */

exports.startCmabApiCallPerformanceTimer = (experimentId: string) => {
    if (__PROFILE__ || __RUM_VERBOSE__) {
        performanceEnv.timeEnd('sendCmabApiInitiateCall');
        performanceEnv.time('sendCmabApiCall');
        cmabApiCallStartTime = new Date().getTime();
        Logger.debug(
            `CMAB / Performance / API call initiated for experiment: ${experimentId}`
        );
    }
};

exports.endCmabApiCallPerformanceTimer = (experimentId: string) => {
    if (__PROFILE__ || __RUM_VERBOSE__) {
        performanceEnv.timeEnd('sendCmabApiCall');
        Logger.debug(
            `CMAB / Performance / API call took: ${new Date().getTime() - cmabApiCallStartTime}ms for experiment: ${experimentId}`
        );
    }
};
